import React, {useContext, useState} from "react"
import Protected from "../../../../components/Protected/Protected"
import {PERMISSIONS} from "../../../../constants/permissions"
import Popup from "reactjs-popup"
import PenIcon from "@mui/icons-material/Create"
import {useSelector} from "react-redux"
import {ThemeContext} from "../../../../styles/theme-context"
import UpdateCalendarPopup from "../Popups/UpdateCalendarPopup"
import {EmptyCard} from "../../../../toolkits/EmptyResult/EmptyCard"
import {useTranslation} from "react-i18next"

const CalendarsCard = ({user, isMyProfile, setUserMessage, receiveUserInfo}) => {
    const { t } = useTranslation("common")

    const [showUpdateCalendarPopup, setShowUpdateCalendarPopup] = useState(false)
    const {hasPermission} = useSelector((state) => state.profile)
    const theme = useContext(ThemeContext)

    return (
        <>
            <div className={`profile-right-calendar ${hasPermission(PERMISSIONS.READ_CALENDAR_EVENTS) ? "clickable" : ""} ${theme.profileCardHover}`}
                onClick={() => setShowUpdateCalendarPopup(true)}>
                <span className="t-h3 profile-font-leading">{t("Calendar")}</span>

                {user?.active_calendar?.name ?
                    <span className="profile-right-calendar-name t-s6">{user?.active_calendar?.name}</span> :
                    <EmptyCard>{t("No calendar")}</EmptyCard>
                }

                <div className="profile-info-card-links">
                    <Protected permissions={[PERMISSIONS.WRITE_CALENDAR_EVENTS]}>
                        <PenIcon onClick={() => setShowUpdateCalendarPopup(true)} className="profile-info-card-pen-icon clickable"/>
                    </Protected>
                </div>
            </div>

            <Popup open={showUpdateCalendarPopup} closeOnDocumentClick={false} onClose={() => setShowUpdateCalendarPopup(false)} modal>
                {close =>
                    <UpdateCalendarPopup
                        user={user}
                        receiveUserInfo={() => receiveUserInfo(user.id, isMyProfile, true)}
                        setUserMessage={setUserMessage}
                        close={close}
                    />
                }
            </Popup>
        </>
    )
}

export default CalendarsCard